import { Guid, ITranslations, Lmid } from "@/types"

export interface IConnectedAsset {
    assetId: Guid
    articleId: Guid
    lmid: Lmid
    labeled: boolean
    articleDescription: string
    altArticleDescription?: string
    features?: ITranslations
}

export default class ConnectedAsset {
    assetId: Guid
    articleId: Guid
    lmid: Lmid
    labeled: boolean
    articleDescription: string
    altArticleDescription?: string
    features?: ITranslations

    constructor(data: IConnectedAsset) {
        this.assetId = data.assetId
        this.articleId = data.articleId
        this.lmid = data.lmid
        this.labeled = data.labeled
        this.articleDescription = data.articleDescription
        this.altArticleDescription = data.altArticleDescription
        this.features = data.features
    }
}
